import React, { useState } from 'react';
import { Card, Table, Tag, Typography, Button, Input, Form, Space, Select, message, Drawer, Descriptions, Radio } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const STATUS_MAP = {
  pending: { label: '待审核', color: 'processing' },
  active: { label: '已通过', color: 'green' },
  rejected: { label: '已驳回', color: 'red' },
};

const MOCK_SAAS_DATA = [
  { key: '1', enterpriseName: '深圳智联科技有限公司', enterpriseId: 'ENT_001', appName: '智能家居控制平台', saasId: 'SAAS_ENT001_A3F8', description: '企业自建的智能家居设备管理SaaS系统', status: 'pending', submitTime: '2026-05-28 14:30:00' },
  { key: '2', enterpriseName: '杭州云智设备有限公司', enterpriseId: 'ENT_008', appName: '云智设备管家', saasId: 'SAAS_ENT008_B2D4', description: '设备远程监控与运维平台', status: 'active', submitTime: '2026-05-27 10:00:00' },
  { key: '3', enterpriseName: '北京万物互联科技有限公司', enterpriseId: 'ENT_003', appName: '万物互联IoT平台', saasId: 'SAAS_ENT003_C7E1', description: '物联网设备统一管理SaaS', status: 'rejected', submitTime: '2026-05-26 16:00:00' },
];

const SaaSAudit = () => {
  const [data, setData] = useState(MOCK_SAAS_DATA);
  const [loading, setLoading] = useState(false);

  const [configVisible, setConfigVisible] = useState(false);
  const [configRecord, setConfigRecord] = useState(null);
  const [auditVisible, setAuditVisible] = useState(false);
  const [auditResult, setAuditResult] = useState('pass');
  const [auditReason, setAuditReason] = useState('');

  const MOCK_CONFIG_TOPICS = [
    { key: 'device_online', name: '设备上线通知', subscribed: true },
    { key: 'device_offline', name: '设备离线通知', subscribed: true },
    { key: 'alarm_event', name: '报警事件', subscribed: true },
    { key: 'ota_result', name: 'OTA升级结果', subscribed: true },
    { key: 'data_report', name: '数据上报', subscribed: false },
  ];

  const onSearch = () => { setLoading(true); setTimeout(() => setLoading(false), 300); };
  const onReset = () => setData(MOCK_SAAS_DATA);

  const handleAuditConfirm = () => {
    if (auditResult === 'reject' && !auditReason.trim()) { message.warning('请输入驳回原因'); return; }
    if (auditResult === 'pass') {
      setData(prev => prev.map(d => d.key === configRecord.key ? { ...d, status: 'active' } : d));
      message.success('审核通过，已生成 AK/SK');
    } else {
      setData(prev => prev.map(d => d.key === configRecord.key ? { ...d, status: 'rejected' } : d));
      message.success('已驳回');
    }
    setAuditVisible(false); setAuditResult('pass'); setAuditReason('');
  };

  const columns = [
    { title: '企业名称', key: 'enterprise', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterpriseName}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {r.enterpriseId}</Text></div>) },
    { title: '应用名称', dataIndex: 'appName', key: 'appName', width: 180 },
    { title: 'SaaS ID', dataIndex: 'saasId', key: 'saasId', width: 180, render: v => <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{v}</Text> },
    { title: '应用描述', dataIndex: 'description', key: 'description', width: 200, render: v => v || '—' },
    { title: '审核状态', dataIndex: 'status', key: 'status', width: 100, render: v => { const c = STATUS_MAP[v]; return <Tag color={c.color}>{c.label}</Tag>; } },
    { title: '提交时间', dataIndex: 'submitTime', key: 'submitTime', width: 170 },
    { title: '操作', key: 'action', width: 200, fixed: 'right', render: (_, r) => {
      if (r.status === 'pending') return <Button type="link" size="small" onClick={() => { setConfigRecord(r); setAuditResult('pass'); setAuditReason(''); setAuditVisible(true); }}>审核</Button>;
      if (r.status === 'active') return <Button type="link" size="small" onClick={() => { setConfigRecord(r); setConfigVisible(true); }}>查看配置</Button>;
      return <Text type="secondary">—</Text>;
    } },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>SaaS审核</Title>
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
          <Form layout="inline">
            <Form.Item style={{ marginBottom: 0 }}>
              <Space.Compact>
                <Select defaultValue="name" style={{ width: 100 }}><Select.Option value="name">企业名称</Select.Option><Select.Option value="id">企业ID</Select.Option></Select>
                <Input placeholder="请输入" allowClear style={{ width: 140 }} />
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}><Input placeholder="SaaS ID" allowClear style={{ width: 180 }} /></Form.Item>
            <Form.Item style={{ marginBottom: 0 }}><Select placeholder="审核状态" allowClear style={{ width: 140 }}><Select.Option value="pending">待审核</Select.Option><Select.Option value="active">已通过</Select.Option><Select.Option value="rejected">已驳回</Select.Option></Select></Form.Item>
            <Form.Item style={{ marginBottom: 0 }}><Space><Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>查询</Button><Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button></Space></Form.Item>
          </Form>
        </Card>
        <Table columns={columns} dataSource={data} rowKey="key" loading={loading} bordered={false} scroll={{ x: 1100 }} pagination={{ showSizeChanger: true, showTotal: t => `共 ${t} 条记录`, pageSize: 10 }} />
      </Card>

      {/* 查看配置抽屉 */}
      <Drawer title={`查看配置 - ${configRecord?.appName || ''}`} open={configVisible} onClose={() => setConfigVisible(false)} width={560}>
        {configRecord && (<>
          <Card title="基本信息" size="small" style={{ marginBottom: 16 }}>
            <Descriptions column={1} size="small">
              <Descriptions.Item label="应用名称">{configRecord.appName}</Descriptions.Item>
              <Descriptions.Item label="SaaS ID"><Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{configRecord.saasId}</Text></Descriptions.Item>
              <Descriptions.Item label="应用描述">{configRecord.description || '—'}</Descriptions.Item>
              <Descriptions.Item label="开启回调"><Tag color={configRecord.status === 'active' ? 'green' : 'default'}>{configRecord.status === 'active' ? '开启' : '关闭'}</Tag></Descriptions.Item>
              {configRecord.status === 'active' && <Descriptions.Item label="回调地址">https://api.example.com/haomeng/callback</Descriptions.Item>}
              <Descriptions.Item label="注册企业">{configRecord.enterpriseName}（{configRecord.enterpriseId}）</Descriptions.Item>
            </Descriptions>
          </Card>
          <Card title="AK/SK" size="small" style={{ marginBottom: 16 }}>
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Access Key ID"><Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{configRecord.saasId ? 'AK_' + configRecord.saasId : '—'}</Text></Descriptions.Item>
              <Descriptions.Item label="Secret Access Key"><Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{configRecord.saasId ? '********xxxx' : '—'}</Text></Descriptions.Item>
            </Descriptions>
          </Card>
          <Card title="订阅 Topic" size="small">
            <Table size="small" rowKey="key" dataSource={MOCK_CONFIG_TOPICS} pagination={false}
              columns={[
                { title: 'Topic', dataIndex: 'key', render: v => <Text code style={{ fontSize: 12 }}>{v}</Text> },
                { title: '名称', dataIndex: 'name' },
                { title: '订阅', dataIndex: 'subscribed', width: 70, render: v => <Tag color={v ? 'green' : 'default'}>{v ? '是' : '否'}</Tag> },
              ]} />
          </Card>
        </>)}
      </Drawer>

      {/* 审核抽屉 */}
      <Drawer title={`审核 - ${configRecord?.appName || ''}`} open={auditVisible} onClose={() => { setAuditVisible(false); setAuditResult('pass'); setAuditReason(''); }} width={560}
        footer={<div style={{ textAlign: 'right' }}><Button onClick={() => { setAuditVisible(false); setAuditResult('pass'); setAuditReason(''); }}>取消</Button><Button type="primary" style={{ marginLeft: 8 }} onClick={handleAuditConfirm}>确认审核</Button></div>}>
        {configRecord && (<>
          <Card title="基本信息" size="small" style={{ marginBottom: 16 }}>
            <Descriptions column={1} size="small">
              <Descriptions.Item label="应用名称">{configRecord.appName}</Descriptions.Item>
              <Descriptions.Item label="SaaS ID"><Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{configRecord.saasId}</Text></Descriptions.Item>
              <Descriptions.Item label="应用描述">{configRecord.description || '—'}</Descriptions.Item>
              <Descriptions.Item label="注册企业">{configRecord.enterpriseName}（{configRecord.enterpriseId}）</Descriptions.Item>
            </Descriptions>
          </Card>
          <Card title="审核操作" size="small">
            <Radio.Group value={auditResult} onChange={e => setAuditResult(e.target.value)} style={{ marginBottom: 12 }}>
              <Radio value="pass">通过</Radio>
              <Radio value="reject">驳回</Radio>
            </Radio.Group>
            {auditResult === 'pass' && <div style={{ color: '#52c41a', fontSize: 13, padding: '8px 12px', background: '#f6ffed', borderRadius: 6 }}>通过后系统将自动生成 AK/SK，SaaS 正式生效。</div>}
            {auditResult === 'reject' && <Form.Item label="驳回原因" required><Input.TextArea rows={3} placeholder="请填写驳回原因" value={auditReason} onChange={e => setAuditReason(e.target.value)} /></Form.Item>}
          </Card>
        </>)}
      </Drawer>
    </div>
  );
};

export default SaaSAudit;
